import { useContext } from "react";
import { Datas } from "../../App";
import p from '../../styles/Profile.module.css';
import BackHome from "../../components/BackHome";

// Android Изображения
import photoAndroid from '../../assets/photo/happ_market.jpg';
import photoAndroid3 from '../../assets/photo/step2.jpg';
import photoAndroid4 from '../../assets/photo/step4.jpg';

function Android() {
    const data = useContext(Datas);

    const androidSteps = [
        { text: 'Скачайте приложение Happ из Google Play', href: 'https://play.google.com/store/apps/details?id=com.happproxy', photo: photoAndroid },
        { text: 'Скопируйте выданную ссылку', href: null },
        { text: 'Нажмите на плюс', href: null, photo: photoAndroid3 },
        { text: 'Вставить из буфера обмена', href: null, photo: photoAndroid4 },
    ];

    return (
        <>
            <BackHome />
            <div className={p.page}>
                <div className={p.section}>
                    <p className={p.section_title} style={{ cursor: 'default' }}>
                        Инструкция по настройке Android:
                    </p>

                    <div className={p.steps}>
                        {androidSteps.map((step, i) => (
                            <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                                <div className={p.step_row}>
                                    <div className={p.step_num}>{i + 1}</div>
                                    <div className={p.step_text}>
                                        {step.href ? (
                                            <a href={step.href} className={p.step_link} target="_blank" rel="noreferrer">
                                                {step.text}
                                            </a>
                                        ) : (
                                            <span>{step.text}</span>
                                        )}
                                    </div>
                                </div>
                                {step.photo && (
                                    <img 
                                        src={step.photo} 
                                        className={p.step_photo} 
                                        alt={`Шаг ${i + 1}`} 
                                        style={{ marginBottom: i !== androidSteps.length - 1 ? '12px' : '0px' }} 
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Android;